import React, { Component } from 'react'
import CartMonthSelect from './CartMonthSelect'

class CustomerCart extends Component{
  constructor(props) {
    super(props);
    const month = { value: this.props.cart__month, label: this.props.cart__month__name }
    this.state = {
      month,
      quantity: this.props.quantity,
      loading: false,
      updated: false,
    }

    this.handleMonthChange = this.handleMonthChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleMonthChange(month) {
    this.setState({ month });
  }

  handleSubmit() {
    this.setState({loading: true})
    const token = localStorage.getItem("admin-token")
    const headers = { "Content-Type": "application/json",};
    const cart_detail = {cart_detail: {month: this.state.month.value, quantity: this.state.quantity, id: this.props.id}}
    const body = JSON.stringify(cart_detail);
    headers["Authorization"] = `Token ${token}`;
    fetch(`/api/admin/cart-detail/update`, {headers, body, method: "POST"})
      .then(res => {
        if (res.status === 200) {
          this.setState({updated: true})
        } else {
          console.log("Server Error!");
          throw res;
        }
      })
  }

  render() {
    return(
      <tr>
        <td>
          <CartMonthSelect
            month={this.state.month}
            handleMonthChange={this.handleMonthChange}
            />
        </td>
        <td>{this.props.product__title}</td>
        <td>{this.state.quantity}</td>
        <td className="t-a-right">
          {
            this.state.updated
            ?
            <p>Uppdaterade</p>
            :
            <div>
              {
                this.state.loading
                ?
                <button className='CartDetail-btn'>
                  <span className="btn-load">
                    <div className="btn-load-circle"></div>
                    <div className="btn-load-circle"></div>
                    <div className="btn-load-circle"></div>
                  </span>
                </button>
                :
                <button
                  onClick={this.handleSubmit}
                  className='CartDetail-btn'>
                  Spara
                </button>
              }
            </div>
          }
        </td>
      </tr>
    )
  }
}

export default CustomerCart



// WEBPACK FOOTER //
// ./src/containers/admin/components/CustomerCart.jsx